import { render, staticRenderFns } from "./TenancyStatement.vue?vue&type=template&id=8e31f578&scoped=true"
import script from "./TenancyStatement.vue?vue&type=script&lang=js"
export * from "./TenancyStatement.vue?vue&type=script&lang=js"
import style0 from "./TenancyStatement.vue?vue&type=style&index=0&id=8e31f578&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e31f578",
  null
  
)

export default component.exports